var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRent = function SvgRent(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 377.297C54.35 377.297 54.35 414.597 91.7 414.597C129.05 414.597 129.05 377.297 166.4 377.297C203.75 377.297 203.75 414.597 241.1 414.597C278.45 414.597 278.45 377.297 315.8 377.297C353.15 377.297 353.15 414.597 390.5 414.597C427.85 414.597 427.9 377.297 465.25 377.297",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M439.352 344.397L470.852 314.747L483.552 314.297H50.7524C43.6024 314.297 40.1524 323.097 45.4024 327.947L62.5524 343.847",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9023 251H92.4023H369.552C392.602 251 414.052 262.8 426.402 282.25L442.652 307.8",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4023 251V307.8",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M381.953 283.797H370.203",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M347.954 283.797H136.504",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "44.51 44.51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.402 283.797H113.652",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 137C148.972 137 168 117.972 168 94.5C168 71.0279 148.972 52 125.5 52C102.028 52 83 71.0279 83 94.5C83 117.972 102.028 137 125.5 137Z",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.367 72.25V97.5336H109.625",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/rent.svg";